export default __webpack_public_path__ + "static/media/avatar.ea7fefc5.png";